document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;

  const header = toggle.closest('.site-header');
  const isOpen = header.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', String(isOpen));
});

const closeMobileMenu = () => {
  const header = document.querySelector('.site-header.is-open');
  if (!header) return;

  const toggle = header.querySelector('[data-menu-toggle]');
  header.classList.remove('is-open');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
};

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-menu-toggle]')) return;

  const openHeader = document.querySelector('.site-header.is-open');
  if (!openHeader) return;

  if (event.target.closest('.site-header__nav a, .site-header__nav button')) {
    closeMobileMenu();
    return;
  }

  if (!event.target.closest('.site-header')) closeMobileMenu();
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 1050) closeMobileMenu();
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const option = select.selectedOptions[0];
  const form = select.closest('form');
  const button = form.querySelector('[data-add-to-cart]');
  const price = document.querySelector('[data-product-price]');

  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }

  if (price && option.dataset.price) {
    price.textContent = option.dataset.price;
  }

  if (option.dataset.mediaId) {
    setActiveProductMedia(option.dataset.mediaId);
  }

  syncVariantButtons(select);
});

const selectedButtonValues = (form) => {
  const selected = {};
  form.querySelectorAll('[data-option-button].is-active').forEach((button) => {
    selected[`option${button.dataset.optionPosition}`] = button.dataset.optionValue;
  });
  return selected;
};

const optionMatchesSelection = (option, selected) => Object.keys(selected).every((key) => {
  return !selected[key] || option.dataset[key] === selected[key];
});

const findVariantOption = (select, selected) => {
  return Array.from(select.options).find((option) => optionMatchesSelection(option, selected));
};

const updateButtonAvailability = (form, select) => {
  const current = selectedButtonValues(form);

  form.querySelectorAll('[data-option-button]').forEach((button) => {
    const testSelection = { ...current, [`option${button.dataset.optionPosition}`]: button.dataset.optionValue };
    const hasAvailableVariant = Array.from(select.options).some((option) => {
      return option.dataset.available === 'true' && optionMatchesSelection(option, testSelection);
    });
    button.disabled = !hasAvailableVariant;
  });
};

const syncVariantButtons = (select) => {
  const form = select.closest('form');
  const option = select.selectedOptions[0];
  if (!form || !option) return;

  form.querySelectorAll('[data-option-button]').forEach((button) => {
    const selected = option.dataset[`option${button.dataset.optionPosition}`] === button.dataset.optionValue;
    button.classList.toggle('is-active', selected);
    button.setAttribute('aria-pressed', String(selected));
  });

  updateButtonAvailability(form, select);
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-option-button]');
  if (!button || button.disabled) return;

  const form = button.closest('form');
  const select = form && form.querySelector('[data-variant-select]');
  if (!form || !select) return;

  form.querySelectorAll(`[data-option-button][data-option-position="${button.dataset.optionPosition}"]`).forEach((optionButton) => {
    const isActive = optionButton === button;
    optionButton.classList.toggle('is-active', isActive);
    optionButton.setAttribute('aria-pressed', String(isActive));
  });

  const match = findVariantOption(select, selectedButtonValues(form));
  if (!match) {
    updateButtonAvailability(form, select);
    return;
  }

  select.value = match.value;
  select.dispatchEvent(new Event('change', { bubbles: true }));
});

const setActiveProductMedia = (mediaId) => {
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery || !mediaId) return;

  const slides = gallery.querySelectorAll('[data-product-media]');
  const thumbs = gallery.querySelectorAll('[data-product-thumb]');
  const target = gallery.querySelector(`[data-product-media="${mediaId}"]`);
  const counter = gallery.querySelector('[data-product-current]');

  if (!target) return;

  slides.forEach((slide) => {
    slide.classList.toggle('is-active', slide.dataset.productMedia === mediaId);
  });

  thumbs.forEach((thumb) => {
    const isActive = thumb.dataset.productThumb === mediaId;
    thumb.classList.toggle('is-active', isActive);
    if (isActive) {
      thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  });

  gallery.dataset.activeMedia = mediaId;
  if (counter && target.dataset.productIndex) counter.textContent = target.dataset.productIndex;
};

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-product-thumb]');
  if (thumb) {
    setActiveProductMedia(thumb.dataset.productThumb);
    return;
  }

  const galleryButton = event.target.closest('[data-product-prev], [data-product-next]');
  if (!galleryButton) return;

  const gallery = galleryButton.closest('[data-product-gallery]');
  if (!gallery) return;

  const slides = Array.from(gallery.querySelectorAll('[data-product-media]'));
  if (slides.length < 2) return;

  const activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  const direction = galleryButton.matches('[data-product-prev]') ? -1 : 1;
  const nextIndex = (activeIndex + direction + slides.length) % slides.length;
  setActiveProductMedia(slides[nextIndex].dataset.productMedia);
});

const cartDrawer = document.querySelector('[data-cart-drawer]');
const sizeGuideDrawer = document.querySelector('[data-size-guide-drawer]');
const searchDrawer = document.querySelector('[data-search-drawer]');
const openCartDrawer = () => {
  if (!cartDrawer) return;
  cartDrawer.classList.add('is-open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('cart-drawer-open');
};

const closeCartDrawer = () => {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('is-open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('cart-drawer-open');
};

const openSizeGuideDrawer = () => {
  if (!sizeGuideDrawer) return;
  sizeGuideDrawer.classList.add('is-open');
  sizeGuideDrawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('size-guide-open');
};

const closeSizeGuideDrawer = () => {
  if (!sizeGuideDrawer) return;
  sizeGuideDrawer.classList.remove('is-open');
  sizeGuideDrawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('size-guide-open');
};

const openSearchDrawer = () => {
  if (!searchDrawer) return;
  searchDrawer.classList.add('is-open');
  searchDrawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('search-open');
  const input = searchDrawer.querySelector('[data-search-input]');
  if (input) window.setTimeout(() => input.focus(), 80);
};

const closeSearchDrawer = () => {
  if (!searchDrawer) return;
  searchDrawer.classList.remove('is-open');
  searchDrawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('search-open');
};

document.addEventListener('click', (event) => {
  const searchOpen = event.target.closest('[data-search-open]');
  if (searchOpen && searchDrawer) {
    event.preventDefault();
    openSearchDrawer();
    return;
  }

  if (event.target.closest('[data-search-close]')) {
    closeSearchDrawer();
    return;
  }

  const sizeGuideOpen = event.target.closest('[data-size-guide-open]');
  if (sizeGuideOpen && sizeGuideDrawer) {
    event.preventDefault();
    openSizeGuideDrawer();
    return;
  }

  if (event.target.closest('[data-size-guide-close]')) {
    closeSizeGuideDrawer();
    return;
  }

  const open = event.target.closest('[data-cart-open]');
  if (open && cartDrawer) {
    event.preventDefault();
    openCartDrawer();
    return;
  }

  if (event.target.closest('[data-cart-close]')) {
    closeCartDrawer();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeCartDrawer();
    closeSizeGuideDrawer();
    closeSearchDrawer();
  }
});

const escapeHTML = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;'
}[character]));

const formatMoney = (cents) => {
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency',
    currency
  }).format((Number(cents) || 0) / 100);
};

const freeShippingThreshold = 6000;

const renderFreeShippingProgress = (cart) => {
  const total = Number((cart && cart.total_price) || 0);
  const remaining = Math.max(0, freeShippingThreshold - total);
  const progress = Math.min(100, Math.round((total / freeShippingThreshold) * 100));
  const unlocked = remaining <= 0;

  return `
    <div class="free-shipping-progress${unlocked ? ' is-unlocked' : ''}" data-free-shipping-progress data-threshold="${freeShippingThreshold}" data-total="${total}">
      <div class="free-shipping-progress__top">
        <strong>Free shipping over ${formatMoney(freeShippingThreshold)}</strong>
        <span>${unlocked ? 'Unlocked' : `${formatMoney(remaining)} away`}</span>
      </div>
      <div class="free-shipping-progress__bar" role="progressbar" aria-label="Free shipping progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${progress}">
        <span style="width: ${progress}%"></span>
      </div>
      <p>${unlocked ? 'Free shipping unlocked. Final delivery details are confirmed at checkout.' : `Add ${formatMoney(remaining)} more to unlock free shipping. Final shipping is confirmed at checkout.`}</p>
    </div>
  `;
};

const renderPaymentTrustRow = (label = 'Secure checkout') => `
  <div class="payment-trust-row" aria-label="${escapeHTML(label)}">
    <span>${escapeHTML(label)}</span>
    <ul>
      <li>Visa</li>
      <li>Mastercard</li>
      <li>PayPal</li>
      <li>Google Pay</li>
    </ul>
  </div>
`;

const updateCartCount = (count) => {
  document.querySelectorAll('.cart-count').forEach((element) => {
    element.textContent = count;
  });
  document.querySelectorAll('[data-cart-open]').forEach((element) => {
    element.setAttribute('aria-label', `Open cart, ${count} item${count === 1 ? '' : 's'}`);
  });
};

const renderCartDrawer = (cart, showNotice = false) => {
  const content = document.querySelector('[data-cart-drawer-content]');
  if (!content || !cart) return;

  updateCartCount(cart.item_count || 0);

  if (!cart.item_count) {
    content.innerHTML = `
      <div class="cart-drawer__empty">
        <h3>Your cart is empty</h3>
        <p>Start with the latest By Night drops and your items will appear here.</p>
        <a class="button" href="/collections">Shop the range</a>
      </div>
    `;
    return;
  }

  const items = cart.items.map((item, index) => {
    const image = item.image
      ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">`
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<span>${escapeHTML(item.variant_title)}</span>`
      : '';

    return `
      <div class="cart-drawer__item">
        <a class="cart-drawer__image" href="${escapeHTML(item.url)}">${image}</a>
        <div class="cart-drawer__info">
          <a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.product_title)}</strong></a>
          ${variant}
          <span>${formatMoney(item.final_price)}</span>
          <label>
            Qty
            <input type="number" name="updates[]" value="${item.quantity}" min="0">
          </label>
          <a class="cart-drawer__remove" href="/cart/change?line=${index + 1}&quantity=0">Remove</a>
        </div>
      </div>
    `;
  }).join('');

  content.innerHTML = `
    ${showNotice ? '<div class="cart-drawer__notice">Added to cart</div>' : ''}
    <form class="cart-drawer__form" action="/cart" method="post">
      <div class="cart-drawer__items">${items}</div>
      <div class="cart-drawer__footer">
        <div class="cart-drawer__subtotal">
          <span>Subtotal</span>
          <strong>${formatMoney(cart.total_price)}</strong>
        </div>
        ${renderFreeShippingProgress(cart)}
        <p>Shipping and discounts are calculated at checkout.</p>
        ${renderPaymentTrustRow('Secure checkout')}
        <div class="cart-drawer__actions">
          <button class="button secondary" type="button" data-cart-close>Continue shopping</button>
          <button class="button" type="submit" name="checkout">Checkout</button>
        </div>
      </div>
    </form>
  `;
};

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  const submitter = event.submitter;
  if (submitter && !submitter.matches('[data-add-to-cart]')) return;

  event.preventDefault();

  const button = form.querySelector('[data-add-to-cart]');
  const buttonLabel = button ? button.querySelector('[data-button-label], span') : null;
  const originalText = buttonLabel ? buttonLabel.textContent : (button ? button.textContent : '');

  if (button) {
    button.disabled = true;
    if (buttonLabel) {
      buttonLabel.textContent = 'Adding...';
    } else {
      button.textContent = 'Adding...';
    }
  }

  try {
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    });
    if (!addResponse.ok) throw new Error('Cart add failed');

    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Cart refresh failed');

    const cart = await cartResponse.json();
    renderCartDrawer(cart, true);
    openCartDrawer();
  } catch (cartError) {
    form.submit();
  } finally {
    if (button) {
      button.disabled = false;
      if (buttonLabel) {
        buttonLabel.textContent = originalText || 'Add to cart';
      } else {
        button.textContent = originalText || 'Add to cart';
      }
    }
  }
});

document.addEventListener('click', async (event) => {
  const remove = event.target.closest('.cart-drawer__remove');
  if (!remove) return;

  const item = remove.closest('.cart-drawer__item');
  const items = item ? [...item.parentElement.querySelectorAll('.cart-drawer__item')] : [];
  const line = items.indexOf(item) + 1;
  if (!line) return;

  event.preventDefault();
  remove.textContent = 'Removing...';

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ line, quantity: 0 })
    });
    if (!response.ok) throw new Error('Cart remove failed');

    const cart = await response.json();
    renderCartDrawer(cart);
    openCartDrawer();
  } catch (removeError) {
    window.location.href = remove.href;
  }
});

const renderSearchResults = (container, products) => {
  if (!container) return;
  if (!products.length) {
    container.innerHTML = '<p class="search-drawer__empty">No matching products found.</p>';
    return;
  }

  container.innerHTML = products.map((product) => {
    const title = escapeHTML(product.title);
    const price = escapeHTML(product.price || '');
    const image = product.image
      ? `<span class="search-result-card__image"><img src="${escapeHTML(product.image)}" alt="${title}"></span>`
      : '<span class="search-result-card__image"></span>';
    return `<a class="search-result-card" href="${escapeHTML(product.url)}">${image}<span><strong>${title}</strong><span>${price}</span></span></a>`;
  }).join('');
};

let searchTimer;

const getCollectionHaystack = (card) => [
  card.dataset.productTitle,
  card.dataset.productType,
  card.dataset.productHandle,
  card.dataset.productTags
].filter(Boolean).join(' ').toLowerCase();

const applyCollectionFilters = () => {
  const grid = document.querySelector('.collection-layout .product-grid');
  if (!grid) return;

  const searchInput = document.querySelector('[data-collection-search]');
  const count = document.querySelector('[data-collection-search-count]');
  const query = searchInput ? searchInput.value.trim().toLowerCase() : '';
  const selectedFilters = Array.from(document.querySelectorAll('[data-client-filter]:checked'))
    .map((input) => input.value.trim().toLowerCase())
    .filter(Boolean);

  let visible = 0;
  grid.querySelectorAll('[data-product-card]').forEach((card) => {
    const haystack = getCollectionHaystack(card);
    const matchesSearch = !query || haystack.includes(query);
    const matchesFilters = selectedFilters.every((filter) => haystack.includes(filter));
    const match = matchesSearch && matchesFilters;
    card.hidden = !match;
    if (match) visible += 1;
  });

  if (count) count.textContent = `${visible} product${visible === 1 ? '' : 's'} showing`;
};

const collapseCollectionFiltersOnMobile = () => {
  if (!window.matchMedia || !window.matchMedia('(max-width: 760px)').matches) return;

  document.querySelectorAll('.collection-filter-form .filter-group').forEach((group) => {
    group.open = false;
  });
};

document.addEventListener('input', (event) => {
  const searchInput = event.target.closest('[data-search-input]');
  if (searchInput) {
    window.clearTimeout(searchTimer);
    const query = searchInput.value.trim();
    const results = searchDrawer && searchDrawer.querySelector('[data-search-results]');

    if (query.length < 2) {
      if (results) results.innerHTML = '<p class="search-drawer__empty">Start typing to search By Night products.</p>';
      return;
    }

    if (results) results.innerHTML = '<p class="search-drawer__empty">Searching...</p>';
    searchTimer = window.setTimeout(async () => {
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
        if (!response.ok) throw new Error('Search failed');
        const data = await response.json();
        const products = (((data || {}).resources || {}).results || {}).products || [];
        renderSearchResults(results, products.map((product) => ({
          title: product.title,
          url: product.url,
          image: product.image,
          price: product.price
        })));
      } catch (searchError) {
        if (results) results.innerHTML = '<p class="search-drawer__empty">Search is unavailable right now. Press enter to view the full search page.</p>';
      }
    }, 220);
    return;
  }

  const collectionSearch = event.target.closest('[data-collection-search]');
  if (!collectionSearch) return;

  applyCollectionFilters();
});

document.addEventListener('change', (event) => {
  if (!event.target.closest('[data-client-filter]')) return;
  applyCollectionFilters();
});

const shippingRates = {
  uk: {
    name: 'United Kingdom',
    standard: { price: 3.99, days: '2-4 business days' },
    express: { price: 5.99, days: '1-2 business days' },
    extraItem: 1.25
  },
  eu: {
    name: 'Europe',
    standard: { price: 8.99, days: '5-9 business days' },
    express: { price: 14.99, days: '3-6 business days' },
    extraItem: 2
  },
  us: {
    name: 'United States',
    standard: { price: 10.99, days: '6-10 business days' },
    express: { price: 18.99, days: '4-7 business days' },
    extraItem: 2.5
  },
  world: {
    name: 'Rest of world',
    standard: { price: 12.99, days: '8-15 business days' },
    express: { price: 24.99, days: '5-10 business days' },
    extraItem: 3
  }
};

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-shipping-estimator]');
  if (!form) return;

  event.preventDefault();

  const formData = new FormData(form);
  const destination = formData.get('destination') || 'uk';
  const service = formData.get('service') || 'standard';
  const itemCount = Math.max(1, Number(formData.get('items')) || 1);
  const rateGroup = shippingRates[destination] || shippingRates.uk;
  const rate = rateGroup[service] || rateGroup.standard;
  const extraItems = Math.max(0, itemCount - 1);
  const shippingPrice = rate.price + (extraItems * rateGroup.extraItem);
  const result = form.querySelector('[data-shipping-estimator-result]');

  if (!result) return;

  result.innerHTML = `
    <strong>${escapeHTML(rateGroup.name)} ${escapeHTML(service)} delivery</strong>
    <span>Estimated production: 2-5 business days. Estimated delivery after dispatch: ${escapeHTML(rate.days)}. Estimated shipping: ${formatMoney(Math.round(shippingPrice * 100))}. Final shipping is confirmed at checkout.</span>
  `;
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-newsletter-form], .newsletter__form');
  if (!form) return;

  event.preventDefault();
  event.stopPropagation();

  const success = form.querySelector('[data-newsletter-success]');
  const error = form.querySelector('[data-newsletter-error]');
  const button = form.querySelector('button[type="submit"]');
  const email = form.querySelector('input[type="email"]');

  if (success) success.hidden = true;
  if (error) error.hidden = true;
  form.dataset.newsletterState = 'submitting';
  if (button) {
    button.disabled = true;
    button.textContent = 'Joining...';
  }

  try {
    const response = await fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
      redirect: 'follow'
    });

    if (!response.ok) throw new Error('Newsletter request failed');

    form.dataset.newsletterState = 'success';
    if (success) success.hidden = false;
    if (email) email.value = '';
  } catch (newsletterError) {
    form.dataset.newsletterState = 'error';
    if (error) error.hidden = false;
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = 'Subscribe';
    }
  }
}, true);

document.addEventListener('input', (event) => {
  const input = event.target.closest('.newsletter__form input[type="email"], [data-newsletter-form] input[type="email"]');
  if (!input) return;

  const form = input.closest('[data-newsletter-form], .newsletter__form');
  if (!form) return;

  const success = form.querySelector('[data-newsletter-success]');
  const error = form.querySelector('[data-newsletter-error]');
  const button = form.querySelector('button[type="submit"]');

  form.dataset.newsletterState = 'editing';
  if (success) success.hidden = true;
  if (error) error.hidden = true;
  if (button) {
    button.disabled = false;
    button.textContent = 'Subscribe';
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('[data-variant-select]');
  if (select) {
    const option = select.selectedOptions[0];
    if (option && option.dataset.mediaId) {
      setActiveProductMedia(option.dataset.mediaId);
    }
    syncVariantButtons(select);
  }

  const params = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-url-filter]').forEach((input) => {
    const values = params.getAll(input.name).map((value) => value.toLowerCase());
    input.checked = values.includes(input.value.toLowerCase());
  });

  applyCollectionFilters();
  collapseCollectionFiltersOnMobile();
});

/* ================================================================
   PDP IMPROVEMENTS - Sticky ATC, Accordion, Scroll Reveal
   ================================================================ */

// ── Sticky ATC bar ──
(function initStickyAtc() {
  const stickyBar = document.querySelector('[data-sticky-atc]');
  const anchor = document.getElementById('pdp-atc-anchor');
  const stickyBtn = document.querySelector('[data-sticky-atc-btn]');
  const mainForm = document.getElementById('product-form');

  if (!stickyBar || !anchor) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', String(entry.isIntersecting));
      });
    },
    { rootMargin: '0px 0px -60px 0px' }
  );
  observer.observe(anchor);

  // Sticky button submits the main product form
  if (stickyBtn && mainForm) {
    stickyBtn.addEventListener('click', () => {
      const submitBtn = mainForm.querySelector('[data-add-to-cart]');
      if (submitBtn && !submitBtn.disabled) submitBtn.click();
    });
  }

  // Keep sticky price/state in sync with variant changes
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
    if (stickyBtn) {
      stickyBtn.disabled = option.dataset.available !== 'true';
      stickyBtn.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
    }
  });
})();

// ── PDP Accordion ──
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-accordion-trigger]');
  if (!trigger) return;

  const bodyId = trigger.getAttribute('aria-controls');
  const body = bodyId ? document.getElementById(bodyId) : null;
  if (!body) return;

  const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

  if (isExpanded) {
    body.style.display = 'none';
    trigger.setAttribute('aria-expanded', 'false');
  } else {
    body.style.display = '';
    trigger.setAttribute('aria-expanded', 'true');
  }
});

// ── Scroll reveal ──
(function initScrollReveal() {
  const els = document.querySelectorAll('.reveal');
  if (!els.length || !('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('visible'));
    return;
  }
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  els.forEach((el) => revealObserver.observe(el));
})();
